<template>
    <div class="inner-box">
         
        <!-- 일반상담 그리드 s.-->
        <div class="table-area">
            <div class="table-b">
                <div class="table-header">
                    <div class="table-name">
                        <h3 class="ico_table_name"> </h3>
                    </div>
                    <div class="grid-tbl-box">
                        <ag-grid-vue 
                            ref="grid" 
                            :style="gridStyle"
                            class="ag-theme-alpine"
                            row-selection="single"
                            :column-defs="columnDefs"
                            :grid-options="gridOptions"
                            :row-data="data"
                            :default-col-def="defaultColDef"
                            :framework-components="frameworkComponent"
                            @grid-ready="onReadyMain"
                            :statusBar="statusBar"
                            @cell-clicked="onCellClicked" />
                    </div>
                </div>
            </div>
        </div>
        <!-- 일반상담 그리드 e.-->
    </div>
</template>


<script>
/**
 * * mixins
 */
import slip from '@/mixin/slip';
import common from '@/mixin/common';

/**
 * * components
 */
import {AgGridVue} from 'ag-grid-vue';
import DhxCalendar from '@/components/Dhx/DhxCalendar.vue';

/**
 * * Modal
 */
import ModelSelectModal from '@/components/AS/NormalConsult/Modal/ModelSelectModal.vue';
import CSChgModal from '@/components/AS/NormalConsult/Modal/CSChgModal.vue';
import CallReadModal from '@/components/AS/NormalConsult/Modal/CallReadModal.vue';


/**
 * Url JOIN
 */
 function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

function _phone(hp){
    return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}

/**
 * 객체내의 값 초기화
 */
 $.ObjectInitialize = function (obj) {
    let self = this;
    self.obj = obj;

    $.each(obj, function (item_name, item) {
        let datatype = $.type(item);

        if (datatype == "number")
            self.obj[item_name] = 0;   // 정수는 0 으로 초기화

        else if (datatype == "string")
            self.obj[item_name] = '';   // 문자는 '' 으로 초기화

        else if (datatype == "boolean")
            self.obj[item_name] = false;   // boolean 는 false 으로 초기화

        else if (datatype == "array")
            self.obj[item_name] = [];   // 배열은 [] 으로 초기화

        else if (datatype == "object")
            self.obj[item_name] = {};   // object는  {} 으로 초기화

    });
} 

export default {
    mixins: [slip, common],
    components: {AgGridVue, DhxCalendar},
    props: ['custParam'],
    data() {
        return {
            form: {
                callClass: '', /** 상담유형 */
                callCatId1: '', /** 상담분류(대) */
                callCatId2: '', /** 상담분류(중) */
                callCatId3: '', /** 상담분류(소) */
                maker: '', /** 제조사 */
                makerNm: '', /** 제조사명 */
                modelGroupNm: '', /** 모델그룹명 */
                modelGroup: '', /** 모델그룹 */
                standardModelNm: '', /** 표준모델 */
                modelNm: '', /** 모델명 */
                modelId: '', /** 모델ID */
                
                question: '', /** 문의내역 */
                answer: '', /** 답변내역 */
                memo: '', /** 기타메모 */
                consultCustNm: '', /** 고객명 */
                consultTelNo: '', /** 연락처 */
                callType: '', /** 처리결과 */
                chargeNm: '', /** 상담원 */
                catId: '' /** 최종 저장될 cat id */
            },
            callClassOpt: [], /** 상담유형리스트 */
            callClassIdOpt: [], /** 상담유형리스트 Id */
            callCatIdOpt1: [], /** 상담분류(대) */
            callCatIdIdOpt1: [], /** 상담분류(대) Id */
            callCatIdOpt2: [], /** 상담분류(중) */
            callCatIdIdOpt2: [], /** 상담분류(중) Id */
            callCatIdOpt3: [], /** 상담분류(소) */
            callCatIdIdOpt3: [], /** 상담분류(소) Id */
            callTypeRadio: [], /** 처리결과 */
            bReadOnly: false,  /** 비활성화 여부 */
            data: [],
            // AG-GRID OPTION [START]
            gridStyle : 'padding-top: 40px; width: 100%;height: 300px; min-height:100px;',
            defaultColDef: {
                resizable: true
                , filter:false
                , sortable: true
            },
            gridApi: null,
            columnApi: null,
            columnDefs: [],
            gridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            frameworkComponent : {
                
            },
            statusBar: null,
            //AG-GRID OPTION [END]
        }
    },
    computed: {
        
    },
    created() {
        this.statusBar = {
            statusPanels: [
                { statusPanel: 'agTotalRowCountComponent', align: 'right' },
            ],
        };
    },
    mounted() {
        this.setNormalList();
    },
    methods: {
        onReadyMain() { 
            //메인그리드 api 정의
            this.gridApi = this.gridOptions.api;
            this.columnApi = this.gridOptions.columnApi;
            this.createColumnDefs();
        },
        setNormalList(param){
            if(param){
                this.data = param || [];
            } else if (this.custParam && this.custParam.tab3AsAgentSelItem){
                this.data = this.custParam.tab3AsAgentSelItem || [];
            }
        },
        createColumnDefs() {
            const vm = this;
            this.columnDefs = [
                {
                    headerName:'구분', 
                    field:'ampmTxt', 
                    width: 250,
                    editable: false,
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName:'월',
                    field:'monYn', 
                    width: 250,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'화',
                    field:'tueYn', 
                    width: 250,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'수',
                    field:'wedYn', 
                    width: 250,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'목',
                    field:'thuYn', 
                    width: 250,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'금',
                    field:'friYn', 
                    width: 250,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'토',
                    field:'satYn', 
                    width: 250,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                }
            ]
        },
        onCellClicked(params) {
            //const idx = params.rowIndex;
            console.log('normal onCellClicked : ', params)
            const field = params.colDef.field;

            if(field === 'callDt') {
                this.openModel(params.data);
            }

        },
        openModel(param) {
            /** 일반상담상세내역 팝업 */

            let vm = this;
            this.$modal.open({
                width: 950,
                component: CallReadModal,
                parent: this,
                props: {
                    data: {
                        callId: param.callId,
                        callTypeRadio: vm.callTypeRadio
                    }
                },
                events: {
                    close(data) {
                        console.log('close', data);
                    },
                }
            });
        },
        openModal() {
            let vm = this;
            this.$modal.open({
                width: 800,
                component: CSChgModal,
                parent: this,
                props: {
                    data: {
                        
                    },
                },
                events: {
                    close(data) {
                        console.log('close', data);
                    },
                }
            });
        },
        onCallClassChange1(value){

            // 초기화
            
            this.callCatIdOpt2 = JSON.parse(JSON.stringify([]))
            this.callCatIdIdOpt2 = JSON.parse(JSON.stringify([]))
            this.form.callCatId2 = ''

            if(this.form.callCatId1 != '') {
                const vIdx = this.callCatIdOpt1.findIndex(x=>x.key === value)
                const vParentId = this.callCatIdIdOpt1[vIdx].key || 0

                this.getCombo({flag: 'CHG1', parentId: vParentId})
                this.form.catId = vParentId
            }
            
            // 초기화
            this.callCatIdOpt3 = JSON.parse(JSON.stringify([]))
            this.callCatIdIdOpt3 = JSON.parse(JSON.stringify([]))
            this.form.callCatId3 = ''
        },
        onCallClassChange2(value){

            const vIdx = this.callCatIdOpt2.findIndex(x=>x.key === value)
            const vParentId = this.callCatIdIdOpt2[vIdx].key || 0

            this.getCombo({flag: 'CHG2', parentId: vParentId})
            this.form.catId = vParentId
        },
        onCallClassChange3(value){

            const vIdx = this.callCatIdOpt3.findIndex(x=>x.key === value)
            const vParentId = this.callCatIdIdOpt3[vIdx].key || 0
             
            this.form.catId = vParentId
        },
        searchModel(){
            /** 모델선택 */
            let vm = this;
            this.$modal.open({
                width: 800,
                component: ModelSelectModal,
                parent: this,
                props: {
                    data: {
                        
                    },
                },
                events: {
                    close(param) {
                        console.log('close', param);
                        vm.form.maker = param.data.maker /** 제조사 */
                        vm.form.makerNm = param.data.makerNm /** 제조사명 */
                        vm.form.modelGroupNm = param.data.modelGroupNm /** 모델그룹명 */
                        vm.form.modelGroup = param.data.modelGroup /** 모델그룹 */
                        vm.form.standardModelNm = param.data.standardModelNm /** 표준모델 */
                        vm.form.modelNm = param.data.modelNm /** 모델명 */
                        vm.form.modelId = param.data.modelId /** 모델ID */
                    },
                }
            });

        },
        viewSpec(){
            /** 사양보기 */
        },
        enableChk(param){
            /** 입력항목 활성화처리 */
            console.log('enableChk start :', param);
            if(param === 'IN_CALL_ID'){
                if(this.form.callType === 'Processing'){
                    // 처리결과가 미완료이면 수정가능해야 함.
                    this.bReadOnly = false;
                } else {
                    this.bReadOnly = true;
                }
                
            } else {
                this.bReadOnly = false;
            }
        }
    }
}
</script>

<style scoped>
.el-form {
    border: 1px solid #c7c7c7;
    padding: 10px;
    border-radius: 5px;
}
</style>